import autoRomance from '../assets/images/auto-romance.jpg';

export const shows = {
    // Current/Upcoming Tour
    featured: {
        id: "tour2025",
        title: "Auto Romance",
        description: "<p>Salut, tu sais, j’ai monté Auto Romance pour partager avec toi un bout de mon univers. Ce spectacle, c’est un peu comme une conversation intime entre nous, où j’explore la relation qu’on entretient avec soi-même. J’ai voulu y mêler beaucoup d’humour, de tendresse et même un brin de folie, pour créer une ambiance décalée et sincère.</p><br /><p>Dans Auto Romance, tu découvriras des situations inattendues – imagine une autruche, un médecin au diagnostic pour le moins surprenant et plein d’autres petites surprises – le tout pour te montrer qu’on peut rire et s’émouvoir de nos petites traverses intérieures. J’ai vraiment mis mon cœur dans ce projet, en espérant que chaque moment sur scène te touche comme si nous étions en train de discuter autour d’un café.</p><br /><p>J’espère que ce spectacle te donnera autant de plaisir à le découvrir que j’en ai eu à le créer, en te faisant voyager à travers des moments de rire, d’émotion et surtout beaucoup d’authenticité.</p>",
        posterImage: autoRomance,
        tourSeason: "autoRomance2025"
    },
    
    // Tour dates
    dates: [
        {
            id: "2025-11-8",
            date: "2025-11-08",
            time: "21:30",
            city: "Aix-en-Provence",
            venue: "La Comédie d'Aix",
            address: "8 avenue de la violette, 13100 Aix en Provence",
            price: "30,50€",
            ticketLink: "https://www.billetreduc.com/365934/evt.htm",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-05-17",
            date: "2025-05-17",
            time: "19:00",
            city: "Auray",
            venue: "Théâtre à l'ouest d'Auray",
            address: "8 RUE DU LÉVENANT - 56400 AURAY",
            price: "26€",
            ticketLink: "https://theatrealouest.com/auray/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },

        {
            id: "2025-03-25",
            date: "2025-03-25",
            time: "20:00",
            city: "Besançon",
            venue: "Comédie de Besançon",
            address: "4 Rue de la Convention, 25000 Besançon",
            price: "14€ - 18€",
            ticketLink: "https://billetterie-comediedebesancon.mapado.com/event/453528-antoine-officieux-dans-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-09-23",
            date: "2025-09-23",
            time: "20:00",
            city: "Bordeaux",
            venue: "Théâtre Trianon de Bordeaux",
            address: "6 Rue Franklin, 33000 Bordeaux",
            price: "25€",
            ticketLink: "https://www.obillet.fr/one-man-show/antoine-officieux",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-11-14",
            date: "2025-11-14",
            time: "21:00",
            city: "Caen",
            venue: "Théâtre à l'ouest de Caen",
            address: "8 Quai Vendeuvre, 14000 Caen",
            price: "26€",
            ticketLink: "https://theatrealouest.com/caen/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-10-10",
            date: "2025-10-10",
            time: "20:30",
            city: "Clermont-Ferrand",
            venue: "Comédie des Volcans",
            address: "15 Bd Louis Chartoire, 63100 Clermont-Ferrand",
            price: "20€",
            ticketLink: "https://comediedesvolcans.fr/evenement/antoine-officieux/",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-09-27",
            date: "2025-09-27",
            time: "20:30",
            city: "Dijon",
            venue: "Bistrot de la Scène",
            address: "203 Rue d'Auxonne, 21000 Dijon",
            price: "27€",
            ticketLink: "https://www.billetreduc.com/v2/PurchaseTunnel#/SeatsSelection?eventId=368890&date=2025-09-27%2020%3A30",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-03-22",
            date: "2025-03-22",
            time: "21:00",
            city: "Le Mans",
            venue: "Comédie Le Mans",
            address: "37 Rue nationale, 72100 Le Mans",
            price: "28€",
            ticketLink: "https://www.16-19.fr/spectacle/antoine-officieux-dans-auto-romance-3/",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-11-21",
            date: "2025-11-21",
            time: "19:00",
            city: "Lille",
            venue: "Le Spotlight - La salle principale",
            address: "100 Rue Léon Gambetta, 59800 Lille",
            price: "18€ - 25€",
            ticketLink: "https://billetterie-spotlight.mapado.com/event/462243-antoine-officieux-auto-romance?eventDate=1943030",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-11-22",
            date: "2025-11-22",
            time: "19:00",
            city: "Lille",
            venue: "Le Spotlight - La salle principale",
            address: "100 Rue Léon Gambetta, 59800 Lille",
            price: "18€ - 25€",
            ticketLink: "https://billetterie-spotlight.mapado.com/event/462243-antoine-officieux-auto-romance?eventDate=1943030",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-04-17",
            date: "2025-04-17",
            time: "20:30",
            city: "Lyon",
            venue: "Théâtre à l'ouest Lyon",
            address: "2 Av. Simone Veil, 69150 Décines-Charpieu",
            price: "25€",
            ticketLink: "https://theatrealouest.com/lyon/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-04-24",
            date: "2025-04-24",
            time: "21:00",
            city: "Lyon",
            venue: "Théâtre à l'ouest Lyon",
            address: "2 Av. Simone Veil, 69150 Décines-Charpieu",
            price: "25€ - 29€",
            ticketLink: "https://theatrealouest.com/lyon/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-03-26",
            date: "2025-03-26",
            time: "20:00",
            city: "Metz",
            venue: "La comédie de Metz",
            address: "3 Rue du Pont Saint-Marcel, 57000 Metz",
            price: "22€",
            ticketLink: "https://comediedemetz.mapado.com/event/449727-antoine-officieux-dans-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-06-25",
            date: "2025-06-25",
            time: "20:30",
            city: "Nantes",
            venue: "Théâtre Francine Vasse",
            address: "18 Rue Colbert, 44000 Nantes",
            price: "30€",
            ticketLink: "https://nantes-spectacles.com/spectacle/antoine-officieux-spectacle",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-04-26",
            date: "2025-04-26",
            time: "21:00",
            city: "Rouen",
            venue: "Théâtre à l'ouest de Rouen",
            address: "26 Quai Gaston Boulet, 76000 Rouen",
            price: "26€",
            ticketLink: "https://theatrealouest.com/rouen/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "sold_out",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-11-15",
            date: "2025-11-15",
            time: "21:00",
            city: "Rouen",
            venue: "Théâtre à l'ouest de Rouen",
            address: "26 Quai Gaston Boulet, 76000 Rouen",
            price: "26€",
            ticketLink: "https://theatrealouest.com/rouen/spectacle/reserver-places/antoine-officieux-auto-romance",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-04-12",
            date: "2025-04-12",
            time: "21:00",
            city: "Saint-Étienne",
            venue: "La comédie Triomphe",
            address: "4 Rue Violette, 42000 Saint-Étienne",
            price: "20,90€",
            ticketLink: "https://www.comedietriomphe.fr/events/antoine-officieux-dans-auto-romance/",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-06-11",
            date: "2025-06-11",
            time: "20:00",
            city: "Toulouse",
            venue: "3 café théâtre",
            address: "40 rue Gabriel Péri, 31000 Toulouse",
            price: "27€",
            ticketLink: "https://www.3tcafetheatre.com/resa/1000323/16947",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-06-12",
            date: "2025-06-12",
            time: "20:00",
            city: "Toulouse",
            venue: "3 café théâtre",
            address: "40 rue Gabriel Péri, 31000 Toulouse",
            price: "27€",
            ticketLink: "https://www.3tcafetheatre.com/resa/1000323/16639",
            status: "available",
            tourSeason: "autoRomance2025"
        },
        {
            id: "2025-05-24",
            date: "2025-05-24",
            time: "20:45",
            city: "Tours",
            venue: "Comédie de Tours",
            address: "39 rue Michelet 37000 Tours",
            price: "24€",
            ticketLink: "https://www.billetteriecomediedetours.fr/reserver/antoine-officieux-auto-romance/116104",
            status: "available",
            tourSeason: "autoRomance2025"
        }
    ]
};